module.exports = __webpack_public_path__ + "static/media/cursor.6c4d3b49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CallTools/Mobile/cursor.svg
// module id = ./src/assets/CallTools/Mobile/cursor.svg
// module chunks = 0